// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bam-js": () => import("/opt/build/repo/src/pages/bam.js" /* webpackChunkName: "component---src-pages-bam-js" */),
  "component---src-pages-imprint-js": () => import("/opt/build/repo/src/pages/imprint.js" /* webpackChunkName: "component---src-pages-imprint-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kellerkind-js": () => import("/opt/build/repo/src/pages/kellerkind.js" /* webpackChunkName: "component---src-pages-kellerkind-js" */),
  "component---src-pages-lifetime-js": () => import("/opt/build/repo/src/pages/lifetime.js" /* webpackChunkName: "component---src-pages-lifetime-js" */),
  "component---src-pages-palettteapp-js": () => import("/opt/build/repo/src/pages/palettteapp.js" /* webpackChunkName: "component---src-pages-palettteapp-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

